<template>
  <b-modal
    v-model="showDeleteModal"
    @ok="confirmRemove"
    centered
    size="md"
    :ok-title="`${deletableItemsCount ? `Deletar ${deletableItemsCount} ${selectedTitle}` : 'Prosseguir'}`"
    ok-variant="danger"
    cancel-title="Cancelar"
    content-class="shadow"
    cancel-variant="outline-secondary"
    title="Atenção!"
  >
    <div class="modal-form">
      <div class="title-modal-info">
        <div v-if="!isLoading">
          <div>
            Serão deletados <span class="font-weight-bold">{{ deletableItemsCount }}</span>
            <span v-if="!!nonDeletableItemsCount">
              de
              <span class="font-weight-bold">{{ selectedItems.length }}</span>
            </span>
            {{selectedTitle}}.
          </div>
          <div v-if="!!detailedBlocked.length" class="py-3">
            Bloqueados (em uso por setores ativos):
            <ul class="m-0 pl-4 mt-2">
              <li v-for="(blocked, i) in detailedBlocked" :key="i">
                <span class="font-weight-bold">{{ blocked.NAME }}</span>
                <span v-if="blocked.sectors && blocked.sectors.length">
                  → {{ blocked.sectors.map((s) => s.NAME).join(", ") }}
                </span>
              </li>
            </ul>
          </div>
          <div v-if="!!explanationsListing.length" class="py-3">
            Pois:
            <ul class="m-0 pl-4 mt-2">
              <li v-for="(explanation, i) in explanationsListing" :key="i">
                {{ explanation.text }}
              </li>
            </ul>
            <!-- <span class="font-weight-bold">{{ nonDeletableItemsCount }}</span> dos {{selectedTitle}} selecionados estão vinculados a um total de
            <span class="font-weight-bold">{{ totalDependentItemsCount }}</span> {{dependentTitle}}. -->
          </div>
        </div>
        <div v-else>
          ...
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    selectedItems: {
      type: Array,
      required: true
    },
    checkBeforeDelete: {
      type: Array,
      default: () => [],
    },
    deleteItemFunc: {
      type: Function,
      default: () => {},
    },
    value: {
      required: true,
      type: Boolean,
    },
    selectedTitle: {
      required: true,
      type: String
    },
    dependentTitle: {
      required: true,
      type: String
    },
    getListOfBlockersWithIds: {
      type: Function,
      default: () => {},
    },
    // Resolve os itens bloqueados COM detalhe (nome + setores) direto da fonte de verdade no backend,
    // para listar no modal. Complementa checkBeforeDelete (que só conta). () => [{ID, NAME, sectors}].
    blockedItemsResolver: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      confirmedDelete: false,
      explanationsBlocked: [],
      detailedBlocked: [],
      totalDependentItems: [],
      nonDeletableItemsIds: [],
      deletableItemsIds: [],
    }
  },
  computed: {
    explanationsListing() {
      return this.explanationsBlocked.filter(exp => exp.count);
    },
    totalDependentItemsCount() {
      return this.totalDependentItems.length;
    },
    nonDeletableItemsCount() {
      return this.nonDeletableItemsIds.length;
    },
    deletableItemsCount() {
      return this.deletableItemsIds.length;
    },
    showDeleteModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
  },
  methods: {
    async confirmRemove() {
      await this.deleteItems();
    },
    async deleteItems() {
      for  (let id of this.deletableItemsIds) {
        const item = this.selectedItems.find(selected => selected.ID == id);
          
        const resp = await this.deleteItemFunc(id);
        const failed = !(resp && resp[0]);

        alert(`${failed ? 'Falha' : 'Sucesso'} ao deletar ${this.selectedTitle} ${item.NAME}`, failed ? 'e' : 's')
      }

      this.$emit("confirm");
    },
    formatExplanation({
      text1,
      text2,
      val1,
    }) {
      return [text1, `(${val1})`, text2, '.'].join(" ");
    },
    async getDeletableItems() {
      const totalItemsIds = this.selectedItems.map(val => val.ID);
    
      let deletableItemsIds = totalItemsIds;
      let nonDeletableItemsIds = [];
      this.explanationsBlocked = [];

      for await (let check of this.checkBeforeDelete) {
        const blockedIds = await check.checkFunc(totalItemsIds);
        // console.log("nos pre block dos solos aqui", blockedIds, totalItemsIds)
        
        for (let id of blockedIds) {
          nonDeletableItemsIds.push(id);
        }

        deletableItemsIds = deletableItemsIds.filter( id => !blockedIds.find(idBlocked => idBlocked === id));
        
        const val1 = blockedIds.length;

        const {
          text1,
          text2,
        } = check;
        
        const explanation = this.formatExplanation({
          text1,
          text2,
          val1,
        });

        this.explanationsBlocked.push({text: explanation, count: val1});
      }

      if (this.blockedItemsResolver) {
        this.detailedBlocked = (await this.blockedItemsResolver(this.selectedItems)) || [];
        const blockedIds = this.detailedBlocked.map((b) => b.ID);
        for (let id of blockedIds) nonDeletableItemsIds.push(id);
        deletableItemsIds = deletableItemsIds.filter((id) => !blockedIds.includes(id));
      }

      this.nonDeletableItemsIds = [...new Set(nonDeletableItemsIds)];
      this.deletableItemsIds = deletableItemsIds;
      this.totalItemsIds = totalItemsIds;

      // this.deletableItemsIds = totalItemsIds.filter( val => !this.nonDeletableItemsIds.find(v => v == val));
    }
  },
  watch: {
    showDeleteModal: {
      immediate: true,
      async handler(val) {
        if(val) {
          this.isLoading = true;
          await this.getDeletableItems();
          this.isLoading = false;
        }
      }
    }
  }
}
</script>